import { DataGridBodyCtrl } from '../controllers/DataGridBodyCtrl';
import { Module } from '../Module';

Module.instance().directive('tbDataGridBody',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'dataGridBody.html',
      scope: {
        cells: '=',
        columnWidths: '=',
        contentWidthsChanged: '&',
        isRowSelected: '&',
        isRowSeparator: '&',
        rowClicked: '&',
        rowHovered: '&',
        rows: '=',
        rowsClickable: '=',
        rowHeight: '=?',
        currentRowIndex: '=?',
        sliceChanged: '&',
        getElementsOfSelectedRows: '=?',
        currentRowObject: '=?',
        alwaysHaveCurrentRow: '=',
        scrollControls: '=?',
        scrollLeftChanged: '&',
        emptyTemplate: '=?',
        emptyTemplateModel: '=?',
        keepColumnWidths: '='
      },
      controller: DataGridBodyCtrl
    };
  }
);
